/**
 * (c) 2021, Nous Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
const fonts = {
  heading: "Helvetica, Arial, sans-serif",
  body: "Helvetica, Arial, sans-serif",
  code: "Source Code Pro, monospace",
};

export default fonts;
